import React, { useEffect, useState } from "react";
import "../css/Chapter.css";
import ChapterVideo from "./ChapterVideo";
import ChapterButtons from "./ChapterButtons";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { URL } from "../../../Redux/common/url";

const Chapter = () => {
  const dispatch = useDispatch();
  const router = useNavigate();
  const { id } = useParams();

  const [post, setpost] = useState({});
  const [reletedProduct, setreletedProduct] = useState([]);
  const [reletedProduct2, setreletedProduct2] = useState({});

  const [reletedProductbrand, setreletedProductbrand] = useState([]);
  const [shopDetails, setshopDetails] = useState([]);
  const [productImage, setproductImage] = useState([]);
  const [productColor, setproductColor] = useState("");
  const [productSize, setproductSize] = useState({});
  const [productSizeList, setproductSizeList] = useState([]);
  const recentProduct = reletedProduct ? reletedProduct : [];



  const [reletedProductresult, setreletedProductresult] = useState({});

  // ✅ New State
  const [videoCompleted, setVideoCompleted] = useState(false);

  const proDetailsCon = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const token = await localStorage.getItem("access_token");
console.log(post);
    const config = {
      headers: {
        Authorization: "bearer " + token,
      },
    };

    const bgl = await fetch(
      URL.API_BASE_URL + `${URL.educationdetailsuser}/${id}`,
      config
    );

    const events = await bgl.json();
    const postData = events?.data;

    setpost(postData?.lessionDetails);
    setreletedProduct2(postData?.examData);
    setreletedProductresult(postData?.getExamresult);
  };

  useEffect(() => {
    proDetailsCon();

    return () => {};
  }, [id]);

  return (
    <div className="w-100 h-100">
      <ChapterVideo
        post={post}
        setVideoCompleted={setVideoCompleted}
      />

      <ChapterButtons
        reletedProductresult={reletedProductresult}
        reletedProduct2={reletedProduct2}
        post={post}
        videoCompleted={videoCompleted}
      />
    </div>
  );
};

export default Chapter;